import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getNeedReload = createSelector(
  (state: RootState) => state.app,
  app => !app.isFormActive && app.needReload,
)
